import { Component, inject, OnInit } from '@angular/core';
import { SidebarDeepLinkService } from './core/services/sidebar/sidebar-deep-link.service';
import { MessageService, PrimeNGConfig } from 'primeng/api';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'nexcore';

  private readonly sidebarDeepLinkService = inject(SidebarDeepLinkService);

  constructor(private config: PrimeNGConfig, private messageService: MessageService) {}

  ngOnInit() {
    this.config.setTranslation({
        clear: 'Löschen',
    });

    // Initialize sidebar deep-linking for ?type=...&show=... query params
    this.sidebarDeepLinkService.init();
}

  onToastAction(message: any) {
    message.data?.action?.();
    this.messageService.clear();
  }
}
